export default "__VITE_ASSET__CGBuhkMj__"